import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card, CardContent } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png"
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent'
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../../user_dashboard/data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player'
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling'
import Skeleton from '@material-ui/lab/Skeleton';
import DifficultySlider from "./feedbackSliderDifficulty";
import PainSlider from "./feedbackSliderPain";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    minWidth: '650px',
  }
}));

const FeedbackComp = (props) => {
  const className = props.className
  
  const classes = useStyles();

  const { innerWidth: width, innerHeight: height } = window;

  const [difficulty, setDifficulty] = useState(0)
  const [pain, setPain] = useState(20)


  const [token, _] = useState(useSelector(state => state.auth.token))

  const submitFeedback = async () => {
    const response = await fetch("https://api.virtus-one.com/treatment/feedback/submit", {
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "POST",
      body: JSON.stringify({
        // Session tracker data
        data: {
          difficulty: difficulty,
          pain: pain
        }
      })
    });

    if (response.ok) {
      const data = await response.json();
      // Handle next exercise
      props.onFeedbackConfirm()
    } else {
      alert("ERROR")
    }
  }


    return (
      <div className={classes.root}>
        <Card>
          <CardContent style={{width: "90%", marginLeft: "2%"}}>
            <DifficultySlider 
              setValue={setDifficulty}
              value={difficulty}
            />
            <PainSlider
              setValue={setPain}
              value={pain}
            />
          </CardContent>
        </Card>
      </div>
    );
};

    
export default FeedbackComp;
